import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { EDTS_TRASH } from '@teetsh/app/src/containers/UserSettings/Trash/EDT/useEDTsTrash';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';

export function useRestoreEDT() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({
      id,
      schoolyearId,
      schoolId,
    }: {
      id: string;
      schoolyearId: string;
      schoolId: string;
    }) =>
      request(
        `/schoolyears/${schoolyearId}/schools/${schoolId}/emplois-du-temps/${id}/restore`,
        { method: 'PATCH' },
      ),
    onSuccess: (_, { id, schoolyearId, schoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [EDTS_TRASH],
      });
      queryClient.invalidateQueries({
        queryKey: [schoolyearId, schoolId, EDT_KEY, 'list'],
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        actions: (
          <ButtonLink
            outlined
            intent="success"
            to={`/annee-scolaire/${schoolyearId}/ecole/${schoolId}/emploi-du-temps/${id}`}
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({
        title: t('userSettings:restore.messages.error'),
      });
    },
  });
  return mutateAsync;
}
